import { render, staticRenderFns } from "./StarterView.vue?vue&type=template&id=096579b6&scoped=true&"
import script from "./StarterView.vue?vue&type=script&lang=js&"
export * from "./StarterView.vue?vue&type=script&lang=js&"
import style0 from "./StarterView.vue?vue&type=style&index=0&id=096579b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096579b6",
  null
  
)

export default component.exports